<!-- ========================= TARIFF ========================= -->

<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'Tariff'">

  <!-- Page Title -->
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>

    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Tariff</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- ================= ROOM RENT AND DEPOSIT ================= -->

  <div class="container">

    <div class="card-all mt-4 mb-3">

      <!-- Tariff Information -->
      <div class="mb-4 mt-2">

        <p class="text-muted mb-1 fontsizeandfamilySans">
          <strong>NISARGOPCHAR GRAMSUDHAR TRUST'S</strong>
        </p>

        <p class="text-muted mb-1 fontsizeandfamilyCalibri">
          Nisargopchar Ashram, Uruli Kanchan, Pune
        </p>

        <p class="text-muted fontsizeandfamilyCalibri">

          Effective From:
          <strong>
            {{ tariffEffectiveFrom | date:'dd-MMMM-yyyy' }}
          </strong>

        </p>

        <p
          class="text-muted"
          style="font-family: Calibri; font-size: 1.26em"
        >
          <strong>TARIFF</strong>
        </p>

      </div>


      <!-- ================= ROOM RENT TABLE ================= -->

      <div class="table-responsive mb-4 fontsizeandfamilyCalibri">

        <table class="table table-striped table-bordered">

          <thead class="thead-dark">

            <tr>

              <th>
                Category of the Room
              </th>

              <th>
                Room Rent Per Day / Per Person
              </th>

              <th>
                Deposit # for 6 nights / 7 Days
              </th>

              <th>
                Deposit # for 14 nights / 15 Days
              </th>

            </tr>

          </thead>


          <tbody>

            <tr *ngFor="let room of roomCategories">

              <!-- Room Category -->
              <td>

                {{ room.Name }}

                <span *ngIf="room.IsAttachedBath">
                  *
                </span>

              </td>


              <!-- Room Rent -->
              <td>
                ₹{{ room.Amount }}
              </td>


              <!-- Deposit 6 Nights -->
              <td>
                ₹{{ room.Deposit6Nights }}
              </td>


              <!-- Deposit 14 Nights -->
              <td>
                ₹{{ room.Deposit14Nights }}
              </td>

            </tr>

          </tbody>

        </table>


        <!-- Room Notes -->

        <div class="d-flex justify-content-between">

          <p class="text-muted fontsizeandfamilyCalibri">

            * Rooms with attached bath and washroom

          </p>

          <p class="text-muted fontsizeandfamilyCalibri">

            # Deposit towards food and paid services

          </p>

        </div>

      </div>


      <!-- ================= CANCELLATION POLICY ================= -->

      <div class="fontsizeandfamilyCalibri">

        <h5
          class="px-3 py-2 rounded border-left border-success text-white border-4"
          style="background-color: #414658"
        >
          Cancellation & Booking Modification Policy
        </h5>


        <ul class="pl-4">

          <p style="color: #282727">

            0% deduction if cancelled 15 days or more before check-in.

          </p>

          <p style="color: #282727">

            50% deduction if cancelled 7 to 14 days before check-in.

          </p>

          <p style="color: #282727">

            75% deduction if cancelled 3 to 6 days before check-in.

          </p>

          <p style="color: #282727">

            90% deduction if cancelled 1 to 2 days before check-in.

          </p>

          <p style="color: #282727">

            100% deduction on the day of check-in.

          </p>

        </ul>


        <div class="d-flex justify-content-center align-items-center">

          <h2>
            Note :-&nbsp;
          </h2>

          <p style="color: #282727">

            The refund amount, if eligible, will be processed within
            21 working days.

          </p>

        </div>

      </div>


      <hr class="bg-dark" />


      <!-- ================= SPECIAL TREATMENTS ================= -->

      <div class="mb-4 mt-2">

        <p
          class="text-muted"
          style="font-family: Calibri; font-size: 1.26em"
        >
          <strong>
            Special Treatments
          </strong>
        </p>

      </div>


      <div class="table-responsive mb-4 fontsizeandfamilyCalibri">

        <table class="table table-striped table-bordered">

          <thead class="thead-dark">

            <tr>

              <th>
                Treatments
              </th>

              <th>
                Charges
              </th>

            </tr>

          </thead>


          <tbody>

            <tr
              *ngFor="let treatment of specialTreatments"
            >

              <td>
                {{ treatment.Name }}
              </td>

              <td>
                ₹{{ treatment.Amount }}
              </td>

            </tr>

          </tbody>

        </table>

      </div>


      <!-- ================= OTHER CHARGES ================= -->

      <div class="mb-4 fontsizeandfamilyCalibri">

        <h5
          class="px-3 py-2 rounded border-left border-primary text-white border-4"
          style="background-color: #414658"
        >

          <i class="fa fa-info-circle text-primary mr-2"></i>

          Other Charges

        </h5>


        <table>

          <tbody class="text-left">

            <tr
              *ngFor="
                let charge of otherCharges;
                let i = index
              "
            >

              <!-- Only create a row for every first item -->
              <ng-container *ngIf="i % 2 === 0">


                <!-- First Charge -->

                <td>

                  {{ charge.Name }}:

                  <strong>
                    ₹{{ charge.Amount }}
                  </strong>

                </td>


                <!-- Second Charge -->

                <td
                  *ngIf="otherCharges[i + 1]"
                >

                  {{ otherCharges[i + 1].Name }}:

                  <strong>
                    ₹{{ otherCharges[i + 1].Amount }}
                  </strong>

                </td>


              </ng-container>

            </tr>

          </tbody>

        </table>

      </div>


      <!-- ================= NOTES ================= -->

      <div class="fontsizeandfamilyCalibri">

        <h5
          class="px-3 py-2 rounded border-left border-success text-white border-4"
          style="background-color: #414658"
        >

          <i class="fa fa-sticky-note text-success mr-2"></i>

          Notes

        </h5>


        <ul class="pl-4">

          <p style="color: #282727">

            Room rent includes Hydrotherapy and Mud therapy charges.

          </p>


          <p style="color: #282727">

            Food, Special Hydrotherapy, Physiotherapy, Neurotherapy,
            Acupuncture, Maid servant and Massage charges are extra.

          </p>


          <p style="color: #282727">

            Charges mentioned above are per bed/per day.

          </p>


          <p style="color: #282727">

            Guest and attendant charges will be same and as per the
            Sadhaka’s charges per day.

          </p>


          <p style="color: #282727">

            Patient have to arrange for attendant if recommended by
            the doctor, which is charged 50% of room rent per day.

          </p>


          <p style="color: #282727">

            We do not have any provision for arranging attendants
            to the Sadhakas.

          </p>


          <p style="color: #282727">

            Laundry service can be availed at an extra cost.

          </p>

        </ul>

      </div>

    </div>

  </div>

</div>



<!-- ========================= CANCELLATION POLICY PAGE ========================= -->

<div
  class="ttm-bgcolor-whiteecolor"
  *ngIf="section == 'CancelationPolicy'"
>

  <div class="container">

    <div class="fontsizeandfamilyCalibri">

      <h5
        class="px-3 py-2 rounded border-left border-success text-white border-4"
        style="background-color: #414658"
      >
        Cancellation & Booking Modification Policy
      </h5>


      <ul class="pl-4">

        <p style="color: #282727">

          0% deduction if cancelled 15 days or more before check-in.

        </p>


        <p style="color: #282727">

          50% deduction if cancelled 7 to 14 days before check-in.

        </p>


        <p style="color: #282727">

          75% deduction if cancelled 3 to 6 days before check-in.

        </p>


        <p style="color: #282727">

          90% deduction if cancelled 1 to 2 days before check-in.

        </p>


        <p style="color: #282727">

          100% deduction on the day of check-in.

        </p>

      </ul>


      <div
        class="d-flex justify-content-center align-items-center"
      >

        <h2>
          Note :-&nbsp;
        </h2>

        <p style="color: #282727">

          The refund amount, if eligible, will be processed within
          21 working days.

        </p>

      </div>

    </div>

  </div>

</div>